import React from 'react';
import { Col, Text } from 'components';
import { StyleSheet } from 'react-native';
import { useDashboardStore } from 'store/Dashboard.Store';

const WARNING_COLOR = '#F5A623';

interface OrdersAtRiskCardProps {
  useMockData?: boolean;
}

const OrdersAtRiskCard: React.FC<OrdersAtRiskCardProps> = ({ useMockData = false }) => {
  const ordersAtRiskCount = useDashboardStore((state) => state.ordersAtRiskCount);
  
  const count = useMockData ? 12 : ordersAtRiskCount;

  return (
    <Col style={styles.kpiCard} flex1>
      <Text fontSize={36} bold style={{ color: WARNING_COLOR }} marginBottom={4}>
        {count}
      </Text>
      <Text fontSize={12} semiBold color="#4B5563" style={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
        ORDERS AT RISK
      </Text>
    </Col>
  );
};

const styles = StyleSheet.create({
  kpiCard: {
    backgroundColor: 'white',
    padding: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
  },
});

export default OrdersAtRiskCard;
